function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M8.532 11.904h1.106V7.298a13.382 13.382 0 0 1 2.548-.238c.485 0 .952.042 1.4.126.448.084.84.238 1.176.462.336.224.604.532.805.924.2.392.301.896.301 1.512 0 .57-.098 1.05-.294 1.442a2.689 2.689 0 0 1-.784.959c-.327.247-.7.425-1.12.532-.42.107-.859.161-1.316.161h-.952v.812h2.24v1.274h-2.24V17H9.638v-1.736H8.532V13.99h1.106v-.812H8.532v-1.274zm2.87-.042h.728a2.8 2.8 0 0 0 .721-.091c.229-.06.427-.156.595-.287.168-.13.301-.306.399-.525a1.93 1.93 0 0 0 .147-.791c0-.57-.154-.973-.462-1.211-.308-.238-.705-.357-1.19-.357a6.41 6.41 0 0 0-.532.021c-.168.014-.303.03-.406.049v3.192zM12 21.75c-5.385 0-9.75-4.365-9.75-9.75S6.615 2.25 12 2.25s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75zm0-1.5a8.25 8.25 0 1 0 0-16.5 8.25 8.25 0 0 0 0 16.5z"
});

var SvgRuble = function SvgRuble(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRuble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Ruble.0adced43.svg";
export { ForwardRef as ReactComponent };